import { memo } from 'react'

import { Button, type ButtonProps } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import * as _ from 'lodash-es'
import { type Connector, useAccount } from 'wagmi'

import { FissionModal } from '../FissionModal'
import { WalletConnectList } from '../WalletConnectList'

export const SelectConnectionButton = memo<
  Omit<ButtonProps, 'onClick'> & {
    message?: string
    isPending: boolean
    onSelect: (args: { connector: Connector }) => void
  }
>(function SelectConnectionButton({
  message = 'Connect Wallet',
  onSelect,
  isPending,
  ...props
}) {
  const account = useAccount()
  const [opened, disclosure_handlers] = useDisclosure(false)

  return (
    <>
      <FissionModal
        closeOnClickOutside={true}
        closeOnEscape={true}
        withCloseButton={true}
        opened={opened}
        onClose={disclosure_handlers.close}
        title={message}
      >
        <WalletConnectList onSelect={onSelect} disabled={isPending} />
      </FissionModal>
      <Button
        size="md"
        {...props}
        onClick={disclosure_handlers.open}
        loading={account.isConnecting}
      >
        {message}
      </Button>
    </>
  )
})
